import {Queue, DeadLetterQueue, QueueProps, IQueue} from 'aws-cdk-lib/aws-sqs'
import {Stack} from 'aws-cdk-lib'
import {Optional} from '@othree.io/optional'
import {StackAccount} from './core'

export type QueueInput = Readonly<{
    id: string
    dlq?: DeadLetterQueue
}>

/** Creates an SQS queue with default and optional per-call configuration overrides. */
export const withQueue = (deps: {
    defaultConfiguration: Partial<QueueProps>
    stack: Stack
}) =>
    (input: QueueInput, configuration?: Partial<QueueProps>): IQueue => {
        const queue = new Queue(deps.stack, input.id, {
            ...deps.defaultConfiguration,
            queueName: input.id,
            deadLetterQueue: input.dlq,
            ...Optional(configuration).orElse({}),
        })
        return queue
    }

/** Constructs an SQS queue ARN from account info and queue name. */
export const queueArnFromName = (deps: { account: StackAccount }) =>
    (queueName: string): string => {
        return `arn:aws:sqs:${deps.account.region}:${deps.account.accountId}:${queueName}`
    }
